import {generatePath} from 'react-router-dom'

export const generateNavigatinPath = ({url,user_type,version ,lang})=>{

    return generatePath(url, {user_type,version,lang })
}

export const getBasePath = (params, pathname ) => {

    return Object.values(params).reduce(
        (path, param) => path.replace('/' + param, ''),
        pathname,
    );
};
